import store from '../store/store';
import { mutatorAction } from 'satcheljs/';

const hideOPayPanel = mutatorAction('HIDE_OPAY_PANEL', function hideOPayPanel() {
    store.shouldShowModalFlexPane = false;
    store.modalFlexPaneContent = undefined;
});

export default hideOPayPanel;
